export default __webpack_public_path__ + "static/premio_home-PE-2e1880551c9ad7e8ce2aff7868c54aaa.png";